import React, { forwardRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faGoogle,
  faTwitter,
  faLinkedinIn,
  faYoutube,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";

const ContactSection = forwardRef((props, ref) => {
  return (
    <div id="contact" className="contact-section" ref={ref}>
      <div className="address-links">
        <h2>RIGHT LENDER</h2>
        <p>
          Perukkal 100 Consultancy Pvt Ltd,
          <br />
          SM Gardenia,Flat No- 203, Sorahunse, Varthur,
          <br />
          Bangalore -560087
          <br />
          <br />
          Call : 93632 58303
          <br />
          Email : support@rightlender.in
        </p>
      </div>

      <div className="contact-main">
        <div className="quick-links">
          <h2>Company</h2>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/aboutus">About</Link>
            </li>
            <li>
              <Link to="/services">Service</Link>
            </li>
            <li>
              <Link to="/get-in-touch">Contact Us</Link>
            </li>
          </ul>
        </div>

        <div className="contact-title">
          <h2>Social Media</h2>

          <div className="social-icons">
            <a
              href="https://www.facebook.com/rightlender"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="social-icons-icon">
                <FontAwesomeIcon icon={faFacebookF} />
              </div>
              <span>Facebook</span>
            </a>
            {/* <a
              href="https://google.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="social-icons-icon">
                <FontAwesomeIcon icon={faGoogle} />
              </div>
              <span>Google</span>
            </a> */}
            <a
              href="https://www.youtube.com/@rightlender?si=kbJDJ775VW5udgdC"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="social-icons-icon">
                <FontAwesomeIcon icon={faYoutube} />
              </div>
              <span>YouTube</span>
            </a>
            <a
              href="https://www.instagram.com/rightlender.in?igsh=MTVxaGxjc2Rhbjl5eg=="
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="social-icons-icon">
                <FontAwesomeIcon icon={faInstagram} />
              </div>
              <span>Instagram</span>
            </a>
            {/* <a
              href="https://x.com/tikx_in?s=11"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="social-icons-icon">
                <FontAwesomeIcon icon={faTwitter} />
              </div>
              <span>Twitter</span>
            </a>
            <a
              href="https://www.linkedin.com/company/tikx/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="social-icons-icon">
                <FontAwesomeIcon icon={faLinkedinIn} />
              </div>
              <span>LinkedIn</span>
            </a> */}
          </div>
        </div>

        <div className="privacy-terms-contact">
          <h2>Legal & Press</h2>
          <div className="legal-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-conditions">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ContactSection;
